// extracted by mini-css-extract-plugin
module.exports = {"root":"GroupTreeLegend_root___lcxk","title":"GroupTreeLegend_title__2fFTg"};